import memoize from 'fast-memoize';

const haveAValue = (resourceName: string) => (value: string) =>
  !value.length && `${resourceName} is required`;
const maxLength = (length: number) => (value: string) =>
  value.length > length &&
  `${value.length - length} character${value.length - length > 1 ? 's' : ''} over the limit`;
const minLength = (length: number) => (value: string) =>
  value.length < length &&
  `Need ${length - value.length} character${length - value.length > 1 ? 's' : ''} more`;
const isRequired = (resourceName: string) => (value: string) => {
  const err = haveAValue(resourceName)(value);

  if (err) {
    return err;
  }

  return !value.match(/([\da-zA-Z]+)/) && `${resourceName} must include at least 1 character`;
};
const isAllNumbers = (resourceName: string) => (value: string) =>
  isNaN(Number(value)) && `${resourceName} must be all numbers`;
const isWholeNumber = (resourceName: string) => (value: string) =>
  !Number.isInteger(Number(value)) && `${resourceName} should be a whole number`;

const ipCidr = (value: string) =>
  !/^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\/[0-9]{1,2})$/.test(value) &&
  'Not a valid IP address CIDR';

const isTime = (value: string) => {
  // [RL] Epic does not allow 24:00
  // eslint-disable-next-line security/detect-unsafe-regex
  if (/^(24)((:|[0-5])\d{0,4})?$/.test(value)) {
    return '24:00 not allowed, use 00:00';
  }

  // eslint-disable-next-line security/detect-unsafe-regex
  if (!/^([01][0-9]|2[0-3]):[0-5][0-9](\.[0-9]{1,9})?$/.test(value)) {
    return 'Not a valid time, use hh:mm';
  }
};

const INPUT_RULES = Object.freeze({
  isAllNumbers: memoize(isAllNumbers),
  isRequired: memoize(isRequired),
  maxLength: memoize(maxLength),
  haveAValue: memoize(haveAValue),
  minLength: memoize(minLength),
  ipCidr: memoize(ipCidr),
  isWholeNumber: memoize(isWholeNumber),
  isTime: memoize(isTime)
});

export default INPUT_RULES;
